import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import AdminLayout from "./Layout/AdminLayout";
import AuthLayout from "./Layout/AuthLayout";
import Documentation from "./Tuning/Pages/Documentation/Documentation";
import "./App.css";
import LoadingScreen from "./Components/LoadingScreen";
import InstallPWA from "./InstallPWA";

const App = () => {
  const themeMode = useSelector((state) => state.themeMode.themeMode);
  const themeColor = useSelector((state) => state.theme.themeColor);
  const borderStroke = useSelector((state) => state.stroke.borderStroke);
  const boxLayout = useSelector((state) => state.boxLayout.boxLayout);
  const monochrome = useSelector((state) => state.monochrome.monochrome);
  const borderRadius = useSelector((state) => state.borderRadius.borderRadius);
  const iconColor = useSelector((state) => state.iconColor.iconColor);
  const gradientColor = useSelector(
    (state) => state.gradientColor.gradientColor
  );

  const location = useLocation();

  const pathname = location.pathname;

  const authTitleMapping = {
    "/signin": "Signin",
    "/signup": "Signup",
    "/password-reset": "PasswordReset",
    "/two-step": "TwoStep",
    "/lockscreen": "Lockscreen",
    "/maintenance": "Maintenance",
    "/404": "NoPage",
  };

  const isAuthRoute = authTitleMapping[pathname];

  const [showInitialLoading, setShowInitialLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowInitialLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  if (showInitialLoading) {
    return <LoadingScreen />;
  }

  console.log("testing....");

  return (
    <>
      <div
        style={{
          position: "fixed",
          bottom: "20px",
          right: "20px",
          zIndex: 9999,
        }}
      >
        <InstallPWA />
      </div>
      {isAuthRoute ? (
        <AuthLayout />
      ) : (
        // pathname.startsWith("/docs") ? (
        //   <Documentation />
        // ) : (
        <AdminLayout
          themeMode={themeMode}
          themeColor={themeColor}
          borderStroke={borderStroke}
          boxLayout={boxLayout}
          monochrome={monochrome}
          borderRadius={borderRadius}
          iconColor={iconColor}
          gradientColor={gradientColor}
        />
      )}
    </>
  );

  // return <RoutesNew />;
};

export default App;

// import React, { useEffect, useState } from "react";
// import { useLocation } from "react-router-dom";
// import { useSelector } from "react-redux";
// import AdminLayout from "./Layout/AdminLayout";
// import AuthLayout from "./Layout/AuthLayout";
// import "./App.css";
// import LoadingScreen from "./Components/LoadingScreen";

// const App = () => {
//   const themeMode = useSelector((state) => state.themeMode.themeMode);
//   const themeColor = useSelector((state) => state.theme.themeColor);
//   const borderStroke = useSelector((state) => state.stroke.borderStroke);
//   const boxLayout = useSelector((state) => state.boxLayout.boxLayout);
//   const monochrome = useSelector((state) => state.monochrome.monochrome);
//   const borderRadius = useSelector((state) => state.borderRadius.borderRadius);
//   const iconColor = useSelector((state) => state.iconColor.iconColor);
//   const gradientColor = useSelector(
//     (state) => state.gradientColor.gradientColor
//   );

//   const location = useLocation();
//   const pathname = location.pathname;

//   const authTitleMapping = {
//     "/signin": "Signin",
//     "/signup": "Signup",
//     "/password-reset": "PasswordReset",
//     "/two-step": "TwoStep",
//     "/lockscreen": "Lockscreen",
//     "/maintenance": "Maintenance",
//     "/404": "NoPage",
//   };

//   const isAuthRoute = authTitleMapping[pathname];

//   const [showInitialLoading, setShowInitialLoading] = useState(true);

//   // 🌐 PWA Install Logic
//   const [deferredPrompt, setDeferredPrompt] = useState(null);
//   const [isInstallable, setIsInstallable] = useState(false);

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setShowInitialLoading(false);
//     }, 2000);

//     return () => clearTimeout(timer);
//   }, []);

//   useEffect(() => {
//     const handler = (e) => {
//       e.preventDefault();
//       setDeferredPrompt(e);
//       setIsInstallable(true);
//       console.log("✅ PWA install prompt available!");
//     };

//     window.addEventListener("beforeinstallprompt", handler);
//     return () => window.removeEventListener("beforeinstallprompt", handler);
//   }, []);

//   const handleInstall = async () => {
//     if (deferredPrompt) {
//       deferredPrompt.prompt();
//       const { outcome } = await deferredPrompt.userChoice;
//       console.log(`User response to the install prompt: ${outcome}`);
//       setDeferredPrompt(null);
//       setIsInstallable(false);
//     }
//   };

//   // 🌀 Initial loading screen
//   if (showInitialLoading) {
//     return <LoadingScreen />;
//   }

//   return (
//     <>
//       {isAuthRoute ? (
//         <AuthLayout />
//       ) : (
//         <AdminLayout
//           themeMode={themeMode}
//           themeColor={themeColor}
//           borderStroke={borderStroke}
//           boxLayout={boxLayout}
//           monochrome={monochrome}
//           borderRadius={borderRadius}
//           iconColor={iconColor}
//           gradientColor={gradientColor}
//         />
//       )}

//       {/* 📱 Manual Install Button */}
//       {isInstallable && (
//         <button
//           onClick={handleInstall}
//           className="btn btn-primary position-fixed bottom-0 end-0 m-3 shadow"
//           style={{
//             borderRadius: "12px",
//             zIndex: 9999,
//           }}
//         >
//           📲 Install App
//         </button>
//       )}
//     </>
//   );
// };

// export default App;
